/**
 * Lineicons (via react-icons/lia)
 * DOCS: https://lineicons.com/icons
 *
 * Existing icon names are preserved and re-exported as Lineicons equivalents
 * so consumer imports keep working.
 */
import {
	LiaTimesSolid,
	LiaArrowLeftSolid,
	LiaTableSolid,
	LiaAngleLeftSolid,
	LiaAngleRightSolid,
	LiaAngleDownSolid,
	LiaAngleUpSolid,
	LiaArrowDownSolid,
	LiaArrowRightSolid,
	LiaArrowUpSolid,
	LiaAngleDoubleRightSolid,
	LiaSearchSolid,
	LiaDownloadSolid,
	LiaTrashSolid,
	LiaInfoCircleSolid,
	LiaUserSolid,
	LiaUsersSolid,
	LiaCoffeeSolid,
	LiaSunSolid,
	LiaChartLineSolid,
	LiaHashtagSolid,
	LiaFilterSolid,
	LiaFileSolid,
	LiaExclamationTriangleSolid,
	LiaCheckCircleSolid,
	LiaClockSolid,
	LiaCopySolid,
	LiaPaperclipSolid,
	LiaCalendarSolid,
	LiaMapMarkerSolid,
	LiaEditSolid,
	LiaLightbulb,
	LiaCarSolid,
	LiaTabletSolid,
	LiaLeafSolid,
	LiaGemSolid,
	LiaPizzaSliceSolid,
	LiaGlobeSolid,
	LiaStarSolid,
	LiaStar,
	LiaEuroSignSolid,
	LiaSortSolid,
	LiaIdCardSolid,
	LiaSignOutAltSolid,
	LiaBalanceScaleSolid,
	LiaCloudSolid,
	LiaHomeSolid,
	LiaChartBarSolid,
	LiaEyeSolid,
	LiaEyeSlashSolid,
	LiaCheckSquareSolid,
	LiaSignInAltSolid,
	LiaEnvelopeSolid,
	LiaPhoneSolid,
	LiaShieldAltSolid,
	LiaQuestionCircleSolid,
} from "react-icons/lia"

// Hero-icon name aliases
const XIcon = LiaTimesSolid
const ArrowLeftIcon = LiaArrowLeftSolid
const TableIcon = LiaTableSolid
const CheckIcon = LiaCheckCircleSolid
const SelectorIcon = LiaSortSolid
const ChevronDownIcon = LiaAngleDownSolid
const ChevronLeftIcon = LiaAngleLeftSolid
const ChevronRightIcon = LiaAngleRightSolid
const CloudDownloadIcon = LiaDownloadSolid
const IdentificationIcon = LiaIdCardSolid
const LogoutIcon = LiaSignOutAltSolid
const UserIcon = LiaUserSolid
const UsersIcon = LiaUsersSolid
const ScaleIcon = LiaBalanceScaleSolid
const CloudIcon = LiaCloudSolid
const BadgeCheckIcon = LiaCheckCircleSolid
const ShieldExclamationIcon = LiaExclamationTriangleSolid
const CurrencyEuroIcon = LiaEuroSignSolid
const HomeIcon = LiaHomeSolid
const ChartBarIcon = LiaChartBarSolid
const SunIcon = LiaSunSolid

// react-icons/fi name aliases
const FiDownload = LiaDownloadSolid
const FiArrowDown = LiaArrowDownSolid
const FiFilter = LiaFilterSolid
const FiChevronLeft = LiaAngleLeftSolid
const FiChevronRight = LiaAngleRightSolid
const FiChevronDown = LiaAngleDownSolid
const FiChevronUp = LiaAngleUpSolid
const FiTrash2 = LiaTrashSolid
const FiInfo = LiaInfoCircleSolid
const FiUser = LiaUserSolid
const FiChevronsRight = LiaAngleDoubleRightSolid
const FiArrowRight = LiaArrowRightSolid
const FiArrowUp = LiaArrowUpSolid
const FiCoffee = LiaCoffeeSolid
const FiSun = LiaSunSolid
const FiTrendingUp = LiaChartLineSolid
const FiHash = LiaHashtagSolid
const FiX = LiaTimesSolid
const FiFile = LiaFileSolid
const FiAlertTriangle = LiaExclamationTriangleSolid
const FiCheckCircle = LiaCheckCircleSolid
const FiClock = LiaClockSolid
const FiCopy = LiaCopySolid
const FiPaperclip = LiaPaperclipSolid
const FiCalendar = LiaCalendarSolid
const FiMapPin = LiaMapMarkerSolid
const FiEdit3 = LiaEditSolid
const FiSearch = LiaSearchSolid

// react-icons/io5 name aliases
const IoBulbOutline = LiaLightbulb
const IoCarOutline = LiaCarSolid
const IoTabletPortraitOutline = LiaTabletSolid
const IoLeafOutline = LiaLeafSolid
const IoDiamondOutline = LiaGemSolid
const IoPizzaOutline = LiaPizzaSliceSolid
const IoGlobeOutline = LiaGlobeSolid
const IoStar = LiaStarSolid
const IoStarOutline = LiaStar

// react-icons/bs name aliases
const BsCurrencyEuro = LiaEuroSignSolid

// react-icons/bi name aliases
const BiShow = LiaEyeSolid
const BiHide = LiaEyeSlashSolid

// Additional react-icons/fi name aliases
const FiActivity = LiaChartLineSolid
const FiCheckSquare = LiaCheckSquareSolid
const FiLogIn = LiaSignInAltSolid
const FiMail = LiaEnvelopeSolid
const FiPhone = LiaPhoneSolid
const FiShield = LiaShieldAltSolid
const FiSunrise = LiaSunSolid

// react-icons/wi name aliases
const WiSunrise = LiaSunSolid
const WiSunset = LiaSunSolid

// Additional Hero-icons aliases
const QuestionMarkCircleIcon = LiaQuestionCircleSolid

// Export
export {
	XIcon,
	ArrowLeftIcon,
	TableIcon,
	FiChevronLeft,
	FiChevronRight,
	FiArrowDown,
	FiSearch,

	// Arrows
	FiChevronDown,
	FiChevronUp,
	FiDownload,
	FiTrash2,
	FiInfo,
	FiUser,
	FiChevronsRight,
	FiArrowRight,
	FiArrowUp,
	FiCoffee,
	FiSun,
	FiTrendingUp,
	FiHash,
	FiFilter,
	FiX,
	FiFile,
	FiAlertTriangle,
	FiCheckCircle,
	FiClock,
	FiCopy,
	FiPaperclip,
	FiCalendar,
	FiMapPin,
	FiEdit3,
	FiActivity,
	FiCheckSquare,
	FiLogIn,
	FiMail,
	FiPhone,
	FiShield,
	FiSunrise,

	// react-icons/bi
	BiShow,
	BiHide,

	// react-icons/wi
	WiSunrise,
	WiSunset,

	// React-icons
	IoBulbOutline,
	IoCarOutline,
	IoTabletPortraitOutline,
	IoLeafOutline,
	IoDiamondOutline,
	IoPizzaOutline,
	IoGlobeOutline,
	IoStar,
	IoStarOutline,

	// Bootstrap Icons
	BsCurrencyEuro,

	// Hero-icons
	CheckIcon,
	SelectorIcon,
	ChevronDownIcon,
	ChevronLeftIcon,
	ChevronRightIcon,
	CloudDownloadIcon,
	IdentificationIcon,
	LogoutIcon,
	UserIcon,
	UsersIcon,
	ScaleIcon,
	CloudIcon,
	BadgeCheckIcon,
	ShieldExclamationIcon,
	QuestionMarkCircleIcon,

	// To be used in Nav (outlined)
	CurrencyEuroIcon,
	HomeIcon,
	ChartBarIcon,
	SunIcon,
}
